import { Notifier } from "@airbrake/browser";

if (window.env.JEKYLL_ENV === "production") {
  try {
    window.airbrake = new Notifier({
      projectId: window.env.AIRBRAKE_PROJECT_ID,
      projectKey: window.env.AIRBRAKE_PROJECT_KEY,
      host: "https://panel.sutty.nl",
    });

    console.originalError = console.error;
    console.error = (...e) => {
      window.airbrake.notify(e.join(" "));
      return console.originalError(...e);
    };
  } catch (e) {
    console.error(e);
  }
}

import * as Turbo from "@hotwired/turbo";
Turbo.start();

import { Application } from "@hotwired/stimulus";
window.Stimulus = Application.start();
window.abortController = undefined;

import GalleryAudioController from "./controllers/gallery_audio_controller";
import CenterScaleController from "./controllers/center_scale_controller";
import InvertController from "./controllers/invert_controller";
import CineController from "./controllers/cine_controller";
import AudioGalleryImagesController from "./controllers/audio_gallery_images_controller";
import CalendarController from "./controllers/calendar_controller";
import WordSelectorController from "./controllers/word_selector_controller";
import GalleryMaskController from "./controllers/gallery_mask_controller";

Stimulus.debug = window.env.JEKYLL_ENV !== "production";
Stimulus.register("gallery-audio", GalleryAudioController);
Stimulus.register("center-scale", CenterScaleController);
Stimulus.register("invert", InvertController);
Stimulus.register("cine", CineController);
Stimulus.register("audio-gallery-images", AudioGalleryImagesController);
Stimulus.register("calendar", CalendarController);
Stimulus.register("word-selector", WordSelectorController);
Stimulus.register("gallery-mask", GalleryMaskController);

document.addEventListener("turbo:load", (event) => {
  document
    .querySelectorAll("a[href^='http://'],a[href^='https://'],a[href^='//']")
    .forEach((a) => {
      a.rel = "noopener";
      a.target = "_blank";
    });

  window.abortController = new AbortController();
});

document.addEventListener("turbo:visit", (event) => {
  window.abortController.abort();
});
